module.exports = __webpack_public_path__ + "img/footer-logo.d1b8f387.png";